import { GenericLookupType } from 'src/core/decorators/generic-lookup/generic-lookup-type.decorator';
import { GenericLookup } from 'src/core/decorators/generic-lookup/generic-lookup.decorator';

@GenericLookupType({
  code: 'Feedback.Status',
})
export class FeedbackStatus {
  @GenericLookup({
    code: 'Feedback.Status.Unread',
  })
  static unread: number;

  @GenericLookup({
    code: 'Feedback.Status.Read',
  })
  static read: number;
}